<template>
  <div>
    <div class="u-txt--fair u-txt--bold u-mrgn-bottom--4 qa-product-history-panel">
      Riwayat Keuntungan
    </div>
    <div class="o-layout o-layout--responsive u-mrgn-bottom--1">
      <div
        v-for="(number, index) in returnTitle.length"
        :key="index"
        class="o-layout__item"
        :class="{ 'u-mrgn-top--4': index >= 4, 'u-3of12': index < 4, 'u-6of12': index >= 4 }"
      >
        <div class="u-fg--charcoal u-txt--base">
          {{ returnTitle[index] }}
        </div>
        <div v-if="returnData[index]" class="u-txt--fair u-txt--bold">
          <RodValue :return-value="returnData[index]" is-desktop />
        </div>
        <div v-else class="u-txt--fair">
          -
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RodValue from 'shared/components/RodValue';

export default {
  name: 'ReturnHistory',
  components: {
    RodValue,
  },
  props: {
    returnTitle: {
      type: Array,
      default: () => [],
    },
    returnData: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
